import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from '@app/client/uploader/desktop/layout/layout.component';
import { SharedModule } from '@app/shared/shared.module';
import { UPLOADER_ROUTES } from '../uploader.routes';
import { SmashHeaderModule } from '@app/shared/modules/smash-header/smash-header.module';
import { SmashPlayerComponent } from '@app/shared/components/smash-player/smash-player.component';
import { SmashThemeModule } from '@app/shared/modules/smash-theme/smash-theme.module';
import { DiscoverComponent } from '../modals/modal-discover/discover.component';

@NgModule({
  declarations: [
    LayoutComponent,
    DiscoverComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(UPLOADER_ROUTES),
    SmashHeaderModule,
    SmashPlayerComponent,
    SmashThemeModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    LayoutComponent,
  ]
})
export class LayoutModule { }
